import React from 'react';
import GeneralLedgerReport from '../Components/Reports/GeneralLedgerReport';

function GeneralLedgerReportPage() {
  return (
    <>
      <GeneralLedgerReport />
    </>
  );
}

export default GeneralLedgerReportPage;
